<template>
  <div class="card">
    <section class="card__header">
      <h4 class="card__title">{{ referral.title }}</h4>
    </section>
    
    <section class="card__listeners">
      <label>
        {{ referral.description}}
      </label>
    </section>
    
    
    <section class="card__footer justify-content-md-end">
      <!-- Editar -->
      <button  @click="updateConsultation" class="btn card__edit">
        <Edit class="card__icon card__icon--MedicalReport" />
      </button>
    </section>
    
  </div>
</template>

<script>
import Edit from '@/assets/icons/edit.svg'

export default {
  components: {
    Edit
  },
  props: {
    referral: Object,
  },
  data(){
    return {
      disableSwitch: false,
      listenersToShow: [],
      listenersOnTooltip: [],
    }
  },
  mounted(){
  },
  methods: {

    updateConsultation(){
      this.$emit('update', this.referral.consultation_status);
    },
    
  }
}
</script>

<style lang="scss" scoped>
.card {
  box-sizing: border-box;
  width: calc(25% - 48px / 4);
  text-align: left;
  background: var(--neutral-000);
  border-radius: 8px !important;
  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 5px;
    padding: 1rem;
  }

  &__title {
    font-weight: 700;
    font-size: 16px;
  }

  &__icon {
    &--MedicalReport {
      width: 25px;
      stroke: var(--border-hover, #A4B1DF);
    }
  }

  &__listeners {
    padding: 1rem;
    height: 85px;
    overflow: hidden;
    text-overflow: ellipsis;
    &__strong {
      font-size: 14px;
    }

    &__label {
      margin-right: 2px;
    }
  }

  &__footer {
    width: 100%;
    align-items: center;
    display: flex;
    padding: 1rem;
    margin-top: 10px;
    justify-content: space-between;
    background: var(--neutral-000);
    border-radius: 0px 0px 8px 8px !important;
    border-top: 1px solid var(--neutral-200);
  }

  &__edit {
    font-size: 1rem !important;
  }

  &__status {
    &__label {
      font-weight: 600;
      margin: 0 0.5rem 0 0;
    }
  }
}
</style>
